export const SET_CURRENT_ADMIN_ORG = 'SET_CURRENT_ADMIN_ORG' 

export const GET_ADMIN_ORG_LIST_SUCCESS = 'GET_ADMIN_ORG_LIST_SUCCESS'
export const GET_ADMIN_ORG_LIST_FAIL = 'GET_ADMIN_ORG_LIST_FAIL'

export const RESPONSE_STATE_SUCCESS = 'RESPONSE_STATE_SUCCESS'
export const RESPONSE_STATE_FAIL = 'RESPONSE_STATE_FAIL' 